import { render, staticRenderFns } from "./SearchHotWord.vue?vue&type=template&id=16d58a06&"
import script from "./SearchHotWord.vue?vue&type=script&lang=js&"
export * from "./SearchHotWord.vue?vue&type=script&lang=js&"
import style0 from "./SearchHotWord.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports